import { getConstant } from '../utils';

export const getRegions = getConstant('GET_REGIONS');
export const getRegion = getConstant('GET_REGION');
